import type React from 'react';
import { useId } from 'react';

import { FieldSet, Label, LabeledControl, Legend, Radio, Text } from '@zillow/constellation-10';

import type { Lease, Section } from '../../../../models/index';
import { LEASE_TERMS } from '../../../../constants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
  lease: Lease;
  legendText?: string;
};

export default function LeaseTermsListBox({ section, setSectionValues, legendText }: Props): JSX.Element {
  const radioGroupName = useId();
  function onOptionChange(event: React.ChangeEvent<HTMLInputElement>): void {
    const { value } = event.currentTarget;
    setSectionValues({
      [LEASE_TERMS.FIELD_NAME.IS_FIXED]: value === LEASE_TERMS.FIELD_NAME.IS_FIXED,
      [LEASE_TERMS.FIELD_NAME.IS_MONTH_TO_MONTH]: value === LEASE_TERMS.FIELD_NAME.IS_MONTH_TO_MONTH,
    });
  }

  const currentValue = section.getFieldValue(LEASE_TERMS.FIELD_NAME.IS_FIXED)
    ? LEASE_TERMS.FIELD_NAME.IS_FIXED
    : section.getFieldValue(LEASE_TERMS.FIELD_NAME.IS_MONTH_TO_MONTH)
      ? LEASE_TERMS.FIELD_NAME.IS_MONTH_TO_MONTH
      : '';

  return (
    <FieldSet required legend={legendText ? <Legend>{legendText}</Legend> : undefined}>
      <LabeledControl
        label={
          <Label>
            {LEASE_TERMS.LABEL.FIXED_HEADER}
            <br />
            <Text css={{ color: 'text.subtle' }}>{LEASE_TERMS.LABEL.FIXED_CONTENT}</Text>
          </Label>
        }
        control={
          <Radio
            name={radioGroupName}
            value={LEASE_TERMS.FIELD_NAME.IS_FIXED}
            checked={currentValue === LEASE_TERMS.FIELD_NAME.IS_FIXED}
            onChange={onOptionChange}
            disabled={section.isFieldDisabled(LEASE_TERMS.FIELD_NAME.IS_FIXED)}
          />
        }
      />
      <LabeledControl
        label={
          <Label>
            {LEASE_TERMS.LABEL.MONTH_TO_MONTH_HEADER}
            <br />
            <Text css={{ color: 'text.subtle' }}>{LEASE_TERMS.LABEL.MONTH_TO_MONTH_CONTENT}</Text>
          </Label>
        }
        control={
          <Radio
            name={radioGroupName}
            value={LEASE_TERMS.FIELD_NAME.IS_MONTH_TO_MONTH}
            checked={currentValue === LEASE_TERMS.FIELD_NAME.IS_MONTH_TO_MONTH}
            onChange={onOptionChange}
            disabled={section.isFieldDisabled(LEASE_TERMS.FIELD_NAME.IS_MONTH_TO_MONTH)}
          />
        }
      />
    </FieldSet>
  );
}
